import { useEffect, useMemo, useRef } from 'react';
import { TrailReport } from 'services/api/dashboard';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';

const aiReplyReportState = atom<TrailReport | undefined>(undefined);

export const useAiReplyReportValue = () => useAtomValue(aiReplyReportState);

export const useMarkAiReplyReport = () => {
  const setAiReplyReport = useSetAtom(aiReplyReportState);
  return () => {
    setAiReplyReport((prev) =>
      prev
        ? {
            ...prev,
            unRead: false,
          }
        : undefined,
    );
  };
};

export const useAIReplyReport = () => {
  const [report, setReport] = useAtom(aiReplyReportState);
  const countRef = useRef(0);

  const { data: trailReportList } = useQuery({
    ...queries.dashboards.trailReportList,
    refetchInterval: 20 * 60 * 1000,
    refetchIntervalInBackground: false,
  });

  const reportInfo = useMemo(() => {
    return {
      hasUnread: report?.unRead ?? false,
      reportId: report?.id,
    };
  }, [report]);

  // 是否显示弹窗
  const popEnable = useMemo(() => report?.unRead && countRef.current === 1, [report?.unRead]);

  useEffect(() => {
    countRef.current = countRef.current + 1;
    const unreadReport = trailReportList?.find((report) => report.unRead);
    if (unreadReport) {
      setReport(unreadReport);
    } else {
      setReport(trailReportList?.[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trailReportList]);

  return {
    popEnable,
    reportInfo,
  };
};

export const useGotoAIReplyReport = () => {
  const nav = useNavigate();
  return (reportId: number) => {
    nav(`/aiReport/reply/${reportId}`);
  };
};
